import React, { useState } from "react";
import { Modal, Input } from "antd";

import useUpdate from "hooks/useUpdate";

const EditIssueKindProblemModal = ({
  handleClose,
  refetch,
  issue_kind_problem_id,
  default_name,
}) => {
  const [name, setName] = useState(default_name);

  const { is_saving, updateAsync } = useUpdate({
    path: `/issue_kind_problems/${issue_kind_problem_id}`,
    onSuccess: refetch,
  });

  const handleOk = async () => {
    try {
      await updateAsync({
        name,
      });
      handleClose();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal
      style={{ top: 45 }}
      maskClosable={false}
      width={700}
      title="Aktualizuj najczęściej zgłaszany problem"
      open={true}
      onOk={handleOk}
      onCancel={handleClose}
      cancelText="Anuluj"
      okText="Zapisz"
      okButtonProps={{
        disabled: !name || is_saving,
        loading: is_saving,
      }}
    >
      <Input.TextArea
        style={{ margin: "20px 0" }}
        value={name}
        onChange={({ target: { value } }) => setName(value)}
        maxLength={150}
        rows={4}
        showCount={true}
      />
    </Modal>
  );
};

export default EditIssueKindProblemModal;
